<template>
	<div
		ref="tableScroll"
		:id="componentId"
		:class="[
			'table-scroll table--fixed-left',
			classes,
			{ 'table-will-scroll': addScrollClass }
		]"
	>
		<!-- @slot Place your table template or components within the TableFixedLeft elements -->
		<slot />
	</div>
</template>

<script>
import { debounce } from "lodash";
import { EventBus } from "@vg-faset/core";
import { UniqueId } from "../../../utilities";
// import Styles from "@vg-faset/core/styles/export-js.scss";
const Styles = require("@vg-faset/core/styles/export-js.scss");

/**
 * The wrapper component listens for certain events and checks to see whether it will become scrollable or not. It will toggle a 'table-will-scroll' class.
 *
 * ##Listeners
 *
 * This component listens for a few EventBus events to update the state of the component:
 *
 * - `accordion:change`
 *
 * - `tab:change`
 *
 *
 */
export default {
	name: "TableFixedLeft",
	props: {
		/**
		 * A string of spaced separated class names to add to the wrapper component.
		 */
		classes: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			addScrollClass: false,
			componentId: new UniqueId("table-fixed-left-").generate()
		};
	},
	mounted() {
		window.addEventListener("resize", debounce(this.checkTable, 100));

		// if an element is hidden then its scrollWidth is 0. So we also hook
		// other events that can hide/show components and check tables again
		EventBus.$on("accordion:change", this.checkTable);

		// The tabs need a moment to render before this runs,
		// and $nextTick doesn't quite do it.
		EventBus.$on("tab:change", () => {
			setTimeout(this.checkTable, 10);
		});

		this.$nextTick(this.checkTable);
	},
	beforeCreate() {
		// set some constants only once on creation
		this.containerPadding = 23 * 2; // .container's have margin: 0 23px;
		this.max = parseInt(Styles.maxWidth, 10);
	},
	methods: {
		checkTable() {
			if (!this.$refs.tableScroll) {
				// just in case table ref hasn't been created yet
				return;
			}
			const scrollWidth = this.$refs.tableScroll.scrollWidth;

			if (scrollWidth === 0) {
				// table is hidden, do nothing
				return;
			}

			const offsetlWidth = this.$refs.tableScroll.offsetWidth;
			const shouldAddClass = scrollWidth > offsetlWidth;

			this.addScrollClass = shouldAddClass;
			/**
			 * This emits whenever the table updates and passes `true` if the table is scrolling and `false` if it is not.
			 *
			 * @action
			 */
			this.$emit("willScroll", shouldAddClass);
			EventBus.$emit(
				"on-table-will-scroll",
				this.addScrollClass,
				this.componentId
			);
		}
	}
};
</script>
